// extracted by mini-css-extract-plugin
export default {"index":"PaginationBasic_index__qJVu2","active":"PaginationBasic_active__GMsUJ"};